import { render, staticRenderFns } from "./ReportFiltersConfig.vue?vue&type=template&id=ec57f3cc&scoped=true"
import script from "./ReportFiltersConfig.vue?vue&type=script&lang=js"
export * from "./ReportFiltersConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec57f3cc",
  null
  
)

export default component.exports